import * as React from 'react';

import { FragmentStoreContext, mapFragmentReducer, initialState, IFragmentStoreContext } from '../../context';

interface ITrackInfrastructureCategoryClick {
  category?: string;
  isSelected: boolean;
}

interface IFragmentStoreProviderProps {
  onInfrastructureCategoryClick?: (params: ITrackInfrastructureCategoryClick) => void;
  onInfrastructurePinClick?: (infrastructureType: string) => void;
}

export const FragmentStoreProvider: React.FC<React.PropsWithChildren<IFragmentStoreProviderProps>> = ({
  children,
  onInfrastructureCategoryClick,
  onInfrastructurePinClick,
}) => {
  const [state, dispatch] = React.useReducer(mapFragmentReducer, initialState);

  const store = React.useMemo<IFragmentStoreContext>(
    () => ({ state, dispatch, onInfrastructureCategoryClick, onInfrastructurePinClick }),
    [onInfrastructureCategoryClick, onInfrastructurePinClick, state],
  );

  return <FragmentStoreContext.Provider value={store}>{children}</FragmentStoreContext.Provider>;
};
